import React from "react";
import { CustomFormSegmentReportData } from "../../../../amorg-common";
import { Card } from "../../../../designSystem/Card";
import { colors } from "../../../../designSystem/colors/color";
import { HorizontalFillBar } from "../../../../designSystem/graphs/HorizontalFillBar";
import { ReportFieldHeader } from "../../[parm]/_components/ReportFieldHeader";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { GraphLegendText } from "../../../../designSystem/graphs/GraphLegend";

type DiscreteValueReportFieldProps = {
    fieldId:string,
    fieldLabel:string,
    valueTexts?:{value:string, text:string}[],
    segmentReports:CustomFormSegmentReportData[]
}
export function DiscreteValueReportField(props:DiscreteValueReportFieldProps):JSX.Element
{
    const valueCounters:{value:string, count:number}[] = [];
    for(const segmentReport of props.segmentReports)
    {
        const fieldSelection = segmentReport.dataSelections.find(s => s.fieldId === props.fieldId);
        if(fieldSelection)
        {
            for(const fs of fieldSelection.selection)
            {
                let valueCounter = valueCounters.find(s => s.value === fs.value);
                if(!valueCounter)
                {
                    valueCounter = { value:fs.value, count:0 };
                    valueCounters.push(valueCounter);
                }
                valueCounter.count+=fs.count;
            }
        }
    }

    const countSum = valueCounters.reduce((acc, s) => acc + s.count, 0);

    return (
        <section>
            <ReportFieldHeader>{props.fieldLabel}</ReportFieldHeader>
            <Card variant="outlined">
                <Flex flexDirection='column' gap={16}>
                
            {valueCounters.map((s) => {

                    const text = props.valueTexts?.find(vt => vt.value === s.value)?.text || s.value;
                    const pct = s.count / countSum * 100;
                    return (
                        <CustomFormReportBar key={props.fieldId + "_" + s.value} 
                            pct={pct} 
                            text={ `${text} (${s.count})`}
                        />
                    );
                })}
            </Flex>
            </Card>
        </section>
    );
}

type CustomFormReportBarProps = {
    pct:number,
    text:string
}
export function CustomFormReportBar(props:CustomFormReportBarProps):JSX.Element
{
    return (
        <Flex flexDirection="column" gap={4}>
            <GraphLegendText style={{fontSize:'14px'}}>{props.text}</GraphLegendText>
            <Flex flexDirection='row' gap={8} justifyContent="center">
                <HorizontalFillBar
                    height="20px"
                    fillPct={props.pct} 
                    fillColor={colors.graphs.survey.answers.verySatisfied}
                    backgroundColor="#ddd" />
                <div style={{width:64}}>{props.pct.toFixed(1)}%</div>
            </Flex>
            
        </Flex>
    );
}